// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b59d4207","769":"acdec4e9"}[chunkId] + ".chunk.js";
};